import axios from "axios";

const apiClient = axios.create({
  baseURL: `https://trown.builtwithdark.com/api`,
  withCredentials: false, // This is the default
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  },
  timeout: 10000
});

export default {
  getGoals() {
    return apiClient.get("/goals");
  },
  getGoal(id) {
    return apiClient.get("/goals/" + id);
  },
  deleteGoal(id) {
    return apiClient.delete("/goals/" + id);
  },
  createGoal(goal) {
    return apiClient.post("/goals", goal);
  },
  updateGoal(goal, key, value) {
    let patch = {
      goalID: goal.goalID,
      [key]: value
    };
    return apiClient.put("/goals", patch);
  }
};
